//fake enum for accessory IDs
export const AID = {
    HAT: "hat",
    SLEEVE_LEFT: "sleeve_left",
    SLEEVE_RIGHT: "sleeve_right",
    SHIRT: "shirt",
    SHOE_LEFT: "shoe_left",
    SHOE_RIGHT: "shoe_right",
    HAND: "hand",
    PANTS: "pants",
}